<template>
	<div id="makePaymentForm">
		<div class="row">
			<div class="panel panel-primary">
				<div class="panel-heading">
					<div class="row">
						<div class="col-xs-12 col-sm-12 col-md-6 col-lg-8">
							<div class="btn-group text-center hidden-xs hidden-sm visible-md visible-lg">
								<button class="btn" v-if="allowBankTransferPayments" v-bind:class="[ selectedPaymentMethod == 'bank_transfer' ? 'active btn-info' : 'btn-info' ]" v-on:click="setSelectedPaymentMethod('bank_transfer')" >Bank Transfer</button>
								<button class="btn" v-if="allowChequePayments" v-bind:class="[ selectedPaymentMethod == 'cheque' ? 'active btn-info' : 'btn-info' ]" v-on:click="setSelectedPaymentMethod('cheque')">Cheque</button>
								<button class="btn" v-if="allowCardPayments" v-bind:class="[ selectedPaymentMethod == 'card' ? 'active btn-info' : 'btn-info' ]" v-on:click="setSelectedPaymentMethod('card')">Credit / Debit Card</button>				
							</div>
						</div>
						<div class=" visible-xs visible-sm hidden-md hidden-lg">
							<div class="btn-group btn-group-sm">
								<button class="btn" v-if="allowBankTransferPayments" v-bind:class="[ selectedPaymentMethod == 'bank_transfer' ? 'active btn-info' : 'btn-info' ]" v-on:click="setSelectedPaymentMethod('bank_transfer')" >Bank Transfer</button>
								<button class="btn" v-if="allowChequePayments" v-bind:class="[ selectedPaymentMethod == 'cheque' ? 'active btn-info' : 'btn-info' ]" v-on:click="setSelectedPaymentMethod('cheque')">Cheque</button>
								<button class="btn" v-if="allowCardPayments" v-bind:class="[ selectedPaymentMethod == 'card' ? 'active btn-info' : 'btn-info' ]" v-on:click="setSelectedPaymentMethod('card')">Credit / Debit Card</button>				
							</div>
						</div>
					</div>
				</div>

				<div class="panel-body">

					<div class="row">

						<div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
							<h4>Payment Summary</h4>
							<div class="well">
								<template v-if="selectedPaymentMethod == 'cheque'">
									<p>Please remember to need to give the cheque / cash to the Club (if you have not already done so):</p>
								</template>
								<template v-if="selectedPaymentMethod == 'bank_transfer'">
									<p>Please remember that you also need to use your online banking to make the transfer with the following details (if you have not already done so):</p>
									<dl class="dl-horizontal">
										<dt>Account Name</dt>
										<dd>{{ this.config.payment_methods.bank_transfer.account_name }}</dd>
										<dt>Sort Code</dt>
										<dd>{{ this.config.payment_methods.bank_transfer.sort_code }}</dd>
										<dt>Account Number</dt>
										<dd>{{ this.config.payment_methods.bank_transfer.account_number }}</dd>
									</dl>
								</template>
								<template v-if="selectedPaymentMethod == 'card'">

					                <table class="table payment-summary">

										<tr><td>Payment Amount</td><td class="text-right">{{ formatCurrency(paymentAmount) }}</td></tr>

										<tr v-show="displayTransactionFees && selectedInvoices !== null && cardCountry"><td>Processing Fees</td><td class="text-right">{{ selectedInvoices !== null && cardCountry ? formatCurrency(transactionFees(cardCountry)) : 'Dependent Upon Card'}}</td></tr>
										
										<tr v-show="displayTransactionFees && selectedInvoices !== null && !cardCountry"><td>Processing Fees (UK Cards)</td><td class="text-right">{{ selectedInvoices !== null && !cardCountry ? formatCurrency(transactionFees('GB')) : ''}}</td></tr>
										<tr v-show="displayTransactionFees && selectedInvoices !== null && !cardCountry"><td>Processing Fees (EU Cards)</td><td class="text-right">{{ selectedInvoices !== null && !cardCountry ? formatCurrency(transactionFees('DE')) : ''}}</td></tr>
										<tr v-show="displayTransactionFees && selectedInvoices !== null && !cardCountry"><td>Processing Fees (Other Cards)</td><td class="text-right">{{ selectedInvoices !== null && !cardCountry ? formatCurrency(transactionFees('US')) : ''}}</td></tr>

										<tr><th>Total Card Payment</th><th class="text-right">{{ formatCurrency(totalInclCardFees) }}</th></tr>
					                </table>

					            </template>
				            </div>
						</div>
                        <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
                            <h4>Payment Details</h4>
                            <div class="well">
                                <div class="row">
                                    <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4">
                                        <div class="input-group">
                                            <span class="input-group-addon">£</span>
                                            <input type="text" v-model.number="totalInclCardFees" name='payment_amount' class = 'form-control select-on-enter' placeholder='Amount' :disabled = "true" ></input>
                                        </div>
                                    </div>
                                </div>
                                <template v-if="selectedPaymentMethod != 'card'">

                                    <div class="row">
                                        <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4">
                                            <div class="form-group">
                                                <label for='payment_date' class="control-label">Payment Date</label>
                                                <div class="input-group">
                                                    <el-date-picker v-model="paymentDate" format="dd/MM/yyyy" :pickerOptions="{firstDayOfWeek: 1}" type="date" id="payment_date" name="payment_date" placeholder='dd/mm/yyyy'></el-date-picker>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-xs-12">
                                            <div class="form-group">
                                                <label for='payment_reference' class="control-label">{{ paymentReferenceLabel }}</label>
                                                <el-tooltip placement="top" :content="paymentReferenceTooltip">
                                                    <i class="el-icon-information"></i>
                                                </el-tooltip>
                                                <input type="text" v-model="paymentReference" name="payment_reference" class="form-control"></input>
                                            </div>
                                        </div>
                                    </div>
                                </template>

                                <template v-if="selectedPaymentMethod == 'card'">


									<div class="row" v-if="(paymentConfig != null) && (paymentConfig.payment_methods.card.allow_saving_cards == true)" v-for="card in paymentConfig.customer.stripe_payment_methods">
										<div class="col-xs-12">
											<div class="form-group">
												<div class="radio">
													<label>
														<input type="radio" :value="card" v-model="saved_card"/>
														<credit-card :last4="card.last4" :brand="card.brand" :expiryMonth="card.exp_month" :expiryYear="card.exp_year"></credit-card>
													</label>
		
												</div>										
											</div>
										</div>
									</div>
									
									<div class="row">
										<div class="col-xs-12">
											<div class="form-group">
												<div class="radio"  v-if="paymentConfig.payment_methods.card.allow_saving_cards">
													<label>
														<input type="radio" :value="null" v-model="saved_card"/>
														Use a new card
													</label>
												</div>
											</div>
										</div>
									</div>

                                    <div class="row" v-if="saved_card == null">
                                        <div class="col-xs-12">
                                            <div class="form-group">
                                                <label for="cardholder-name">Card Holder Name</label>
                                                <input type="text" id="cardholder-name" class="form-control" v-model="cardholder_name"/>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row" v-if="saved_card == null">
                                        <div class="col-xs-12">
                                            <div class="form-group">
                                                <label for='elementsCreditCard' class="control-label">Card Details</label>
                                                <div id="elementsCreditCard"></div>
                                            </div>
                                        </div>
                                    </div>
									<div class="row" v-if="saved_card == null">
										<div class="col-xs-12">
											<div class="form-group">
									<div class="checkbox"  v-show="saved_card == null" v-if="paymentConfig.payment_methods.card.allow_saving_cards">
										<label for="save-card">
											<input type="checkbox" id="save-card" v-model="save_card"/>
											Save Card Details
										</label>
									</div>
											</div>
										</div>
									</div>
									

									
                                  <div v-show="errorMessage" class="alert alert-danger">
                                    {{ errorMessage }}
                                  </div>
                                  <div v-show="successMessage" class="alert alert-success">
                                    {{ successMessage }}
                                  </div>


                                </template>
                                <button class="btn btn-success btn-lg" v-on:click="makePayment" @click.prevent='makingPayment()'>{{ makePaymentLabel }}</button>
                            </div>
                        </div>
					</div>

					<div class="row">
						<div class="col-xs-12">
						<h4>Open Invoices</h4>
						</div>
					</div>

						<table class="table table-striped table-bordered table-responsive">
							<thead>
								<tr>
									<th class="text-center">&nbsp<input type="checkbox" :value="1" v-on:change="toggleSelectAllInvoices" :checked="selectAllInvoices"></th>
									<th class="text-center">Invoice Number</th>
									<th class="text-center">Invoice Date</th>
									<th>Description</th>
									<th class="text-right">Invoice Total</th>
									<th class="text-right">Amount Due</th>
								</tr>
							</thead>
							<tbody>

								<tr v-for="openInvoice in openInvoices" v-show="invoiceSupportsSelectedPaymentMethod(openInvoice)">
									<td class="text-center"><input type="checkbox" :value="openInvoice" id="selectedInvoices" v-model="selectedInvoices" v-on:change="updatePaymentAmountFromSelectedInvoices"></td>
									<td class="text-center">{{ openInvoice.invoice_number}}</td>
									<td class="text-center">{{ openInvoice.invoice_date_formatted }}</td>
									<td>{{ openInvoice.description }}</td>
									<td class="text-right">{{ openInvoice.formatted_total }}</td>
									<td class="text-right">{{ openInvoice.formatted_balance_due }}</td>
								</tr>
							</tbody>
						</table>

				</div>



			</div>

		</div>
	</div>
</template>

<style scoped>
	table.payment-summary {
	}
	table.payment-summary tr {
		border-bottom: 1px solid #000;
	}
	table.payment-summary tr>td {
		padding: 0.5em 0.2em;
	}
	table.payment-summary tr>th {
		border-top: 2px solid;
		padding: 0.5em 0.2em;
	}
	.StripeElement {
		font-size: 14px;
		background-color: #fff;
		padding: 12px 12px;
		border: 1px solid #ccc;
		border-radius: 4px;
	}
</style>

<script>
	import { DatePicker, Message, Icon, Tooltip, Loading } from 'element-ui';
	import lang from 'element-ui/lib/locale/lang/en';
	import locale from 'element-ui/lib/locale';
  locale.use(lang);

	export default {
		  components: { DatePicker, Message, Tooltip, Icon, Loading },
			props: ['account', 'config'],
			data: function () {
					return {
							paymentConfig: this.config,
							selectedPaymentMethod: null,
							paymentAmount: null,
							paymentDate: null,
							paymentReference: null,
							openInvoices: [],
							selectedInvoices: [],
							paymentInProgress: false,
							requiresAction: false,
							successMessage: null,
							errorMessage: null,
							cardholder_name: '',
							paymentMethod: null,
						saved_card: null,
						save_card: false,
						selectAllInvoices: true,
					}
			},
			computed: {
				paymentReferenceLabel: function() {
					if (this.selectedPaymentMethod == 'cheque') {
						return 'Cheque / Cash Details';
					}
					return 'Payment Reference';
				},
				paymentReferenceTooltip: function() {
					if (this.selectedPaymentMethod == 'cheque') {
						return 'Please provide details of the cheque / cash include the name of the person you gave the money to and the date you gave them the money.';
					}
					return 'Please provide the payment reference used for the bank transfer';
				},
				allowCardPayments: function() {
					return this.paymentConfig.payment_methods.card.allowed_payment_plans ||
					this.paymentConfig.payment_methods.card.allowed_other
				},
				allowBankTransferPayments: function() {
					return this.paymentConfig.payment_methods.bank_transfer.allowed_payment_plans ||
					this.paymentConfig.payment_methods.bank_transfer.allowed_other
				},
				allowChequePayments: function() {
					return this.paymentConfig.payment_methods.cheque.allowed_payment_plans ||
					this.paymentConfig.payment_methods.cheque.allowed_other
				},
				makePaymentLabel: function() {
					if (this.selectedPaymentMethod == 'card') {
						return 'Make Payment';
					}
					return 'Record Payment Information';
				},
				cardFees: function() {
					console.log('cardFees');
					console.log(this.paymentConfig.payment_methods.card.absorb_transaction_fees);
					console.log(this.selectedPaymentMethod);
					if ((this.selectedPaymentMethod != 'card') || (this.paymentConfig.payment_methods.card.absorb_transaction_fees  == true)) {
						return 0;
					}
					return this.transactionFees(this.cardCountry);
				},
				totalInclCardFees: function() {
					return this.roundHalfUp(this.paymentAmount + this.cardFees, 2);
				},
				totalInclCardFeesPence: function() {
					return this.totalInclCardFees * 100;
				},
				paymentAmountInPence: function() {
					return this.roundHalfUp(this.paymentAmount, 2) * 100;
				},
				cardFeesInPence: function() {
					return this.cardFees * 100;
				},
				selectedInvoicesTotal: function() {
					var totalSelectedValue = 0;
					for (var selectedInvoice of this.selectedInvoices) {
						totalSelectedValue += selectedInvoice.balance_due;
					}
					return totalSelectedValue;
				},
				cardCountry: function() {
					let country;
					if (this.saved_card) {
						country = this.saved_card.country;
					}
					else if (this.paymentMethod) {
						country = this.paymentMethod.card.country;
					}
					else {
						return null;
					}
					return country;
				},
				displayTransactionFees: function() {
					return this.paymentConfig != null && this.selectedInvoices !== null && !this.paymentConfig.payment_methods.card.absorb_transaction_fees
				},
			},
			mounted() {
				console.log('Make Payment component mounted.');
				this.setDefaultPaymentMethod();
				this.getOpenInvoices();
				this.resetForm();
				console.log(this.paymentDate);
			},
			methods: {
				makingPayment() {
					return this.paymentInProgress || this.requiresAction;
				},
				setDefaultPaymentMethod() {
					var default_payment_method;
					if (this.allowCardPayments) {
						default_payment_method = 'card';
					}
					else if (this.allowBankTransferPayments) {
						default_payment_method = 'bank_transfer';
					}
					else if (this.allowChequePayments) {
						default_payment_method = 'cheque';
					}
					this.setSelectedPaymentMethod(default_payment_method);
				},
				setupStripe() {
					console.log('setupStripe');
					console.log('Stripe Token: ' + StripeConfig.stripeToken);
					this.stripe = Stripe(StripeConfig.stripeToken, {
					  stripeAccount: StripeConfig.stripeClubAccount
					});
					this.elements = this.stripe.elements();
						const style = {
							base: {
								// Add your base input styles here. For example:
								color: '#303238',
								fontSize: '14px',
								lineHeight: '14px',
	
							}
						};
					this.card = this.elements.create('card', {
						style: style
					});
					this.card.mount('#elementsCreditCard');
					this.card.on('change', (event) => {
						console.log(event);
						this.saved_card = null;
					});
				},
				getOpenInvoices() {
					this.loadingInstance = Loading.service({text: "Loading invoices..."});
					axios.get('/account/api/invoices/open').then((response) => {
						console.log(response.data);
						this.openInvoices = response.data;
						this.selectedInvoices = this.openInvoices;
						this.updatePaymentAmountFromSelectedInvoices();
					}).catch((error) => {
						this.handleHTTPError(error);
					}).finally(()=>{
						this.loadingInstance.close()
					});
				},
				updatePaymentAmountFromSelectedInvoices() {
					this.paymentAmount = this.selectedInvoicesTotal;
					this.updateAllSelectedFlag();
				},
				setSelectedPaymentMethod(newPaymentMethod) {
					this.selectedPaymentMethod = newPaymentMethod;
					this.filterSelectedInvoicesForPaymentMethod();
					this.updatePaymentAmountFromSelectedInvoices();
					if (newPaymentMethod == 'card') {
						this.$nextTick(function () {
							this.setupStripe();
						});
					}
				},
				toggleSelectAllInvoices()
				{
					// Check the current status to toggle the selection
					if (this.selectAllInvoices == false) {
						// Toggling from unchecked to checked
						this.selectedInvoices = this.openInvoices;
					}
					else {
						// toggling from checked to unchecked
						this.selectedInvoices = [];
					}
					// Update the toggle flag
					this.updateAllSelectedFlag();
				},
				updateAllSelectedFlag()
				{
					this.selectAllInvoices = this.selectedInvoices.length == this.openInvoices.length;
				},

				filterSelectedInvoicesForPaymentMethod() {
		            console.log('filterSelectedInvoicesForPaymentMethod');
					this.selectedInvoices = this.selectedInvoices.filter((element) => {
						return this.invoiceSupportsSelectedPaymentMethod(element);
            		});
				},
				invoiceSupportsSelectedPaymentMethod(invoiceToCheck) {
					// Check for payment methods supported for payment plan invoices
					console.log('Checking invoice ' + invoiceToCheck.source);
          
					if (invoiceToCheck.source == 'Payment Plan') {
						return this.paymentConfig.payment_methods[this.selectedPaymentMethod]['allowed_payment_plans'];
					}
					// Now check for payment methods supported by other invoices
					return this.paymentConfig.payment_methods[this.selectedPaymentMethod]['allowed_other'];
				},
				resetForm() {
					console.log('resetForm');
					this.paymentDate = moment().tz('Europe/London');
					this.paymentReference = '';
					this.paymentAmount = 0;
					this.selectedInvoices = this.openInvoices;
					// this.filterSelectedInvoicesForPaymentMethod();
					this.updatePaymentAmountFromSelectedInvoices();
				},
				makePayment() {
					console.log('Making payment');
					console.log(this.paymentInProgress);
					if (this.paymentInProgress) {
						console.log('A payment is already in progress - ignoring double-click');
 						this.$message({message: 'Your payment is already being processed... please wait', type: 'error'});
						return;
					}
					if (this.paymentAmountInPence == 0) {
						console.log('Ignoring payment of 0 value');
						this.$message({message: 'Your payment must be for more than £0.00', type: 'error'});
						return;
					}
					console.log('Setting PaymentInProgress = true');
					this.paymentInProgress = true;
					console.log(this.paymentInProgress);
					this.loadingInstance = Loading.service({text: "Processing payment... please wait"});
					if (this.selectedPaymentMethod == 'card') {
						console.log('Making card payment');
						this.createPaymentMethod()
							.then( (payment_method) => {
								console.log(payment_method);
								console.log(`Payment Method ID: ${payment_method.id}`);
								if (payment_method) {
									this.createCardPayment(payment_method);
								}
							}).catch(error => {
								console.log(error);
							})
						.finally( () => {
							this.paymentInProgress = false;
							this.loadingInstance.close();
							this.getOpenInvoices();
						});
					}
					else {
						console.log('Making offline payment');
						this.createOfflinePayment();
						this.paymentInProgress = false;
						this.loadingInstance.close();
					}
				},
				async createPaymentMethod() {
		            console.log('createPaymentMethod');
					if (this.saved_card != null) {
						console.log('using saved card id '  + this.saved_card.id);
						return this.saved_card;
					}
					console.log('createPaymentMethod after returning saved card');
					return this.stripe.createPaymentMethod({
						type: 'card',
						card: this.card,
						billing_details: {
							name: this.cardholder_name,
						},
					})
					.then(response => {
						console.log('createPaymentMethod response');
						console.log(response);
						if (response.error) {
						  this.$message({message: response.error.message, type: 'error'});
						  return false;
						}
						this.paymentMethod = response.paymentMethod;
						return response.paymentMethod;
					})
					.catch(function(error) {
						console.log('ERROR creating payment method');
						console.log(error);
					});
		        },
				createOfflinePayment() {
					axios.post('/account/api/payments', {
						payment: {
							selected_payment_method: this.selectedPaymentMethod,
							payment_amount: this.paymentAmountInPence, // We send in pence to the API,
							payment_date: this.paymentDate,
							payment_reference: this.paymentReference,
							selected_invoices: this.selectedInvoices
						}
					}).then((response) => {
						console.log(response.data);
						this.$message({message: 'Your payment was created successfully', type: 'success'});
						this.getOpenInvoices();
						this.resetForm();
					}).catch((error) => {
						this.handleHTTPError(error);
						this.$message({message: 'There was a problem creating your payment', type: 'error'});
					})
					.finally(() => {
						this.loadingInstance.close();
						this.paymentInProgress = false;						
					});
				},
				createCardPayment(payment_method) {
					console.log('createCardPayment');
					this.paymentInProgress = true;
					console.log(`Paymentmethod Id: ${payment_method}`);
					console.log(this.totalInclCardFeesPence);
					console.log(this.cardCountry);
					// return;
					axios.post('/account/api/payments', {
						payment: {
							selected_payment_method: this.selectedPaymentMethod,
							payment_amount: this.paymentAmountInPence, // We send in pence to the API
							payment_date: this.paymentDate,
							payment_reference: this.paymentReference,
							selected_invoices: this.selectedInvoices,
							total_incl_card_fees_pence: this.totalInclCardFeesPence,
							card_fees: this.cardFeesInPence,
						},
						saveCard: this.save_card,
						paymentMethod: payment_method,
						paymentMethodId: payment_method.id
					}).then((response) => {
						this.loadingInstance.close();
						console.log('Create card payment was successful');
						this.$message({message: 'Your payment was created successfully', type: 'success'});
						this.getOpenInvoices();
						this.resetForm();
						this.paymentInProgress = false;
						this.loadingInstance.close();
						// this.card.clear();
						console.log(response.data);
					}).catch((error) => {
						// this.card.clear();

						this.handleHTTPError(error);
						if (error.response.data.status === 'PaymentActionRequired') {
							this.requiresAction = true;
							this.$message({ message: 'Your payment requires additional confirmation', type: 'success'});
							this.stripe.confirmCardPayment(
								error.response.data.data.cashier_payment.client_secret, {
									payment_method: error.response.data.data.cashier_payment.payment_method
								}
							).then( result => {

								if (result.error) {
									// error.code might be: payment_intent_authentication_failure or card_declined or something else, but in any case, we need a new payment method
									// this.card.clear();
									this.$message({type: 'error', message: `There was a problem processing your payment. ${result.error.message}`});
								} else {
									this.$message({type: 'success', message: 'The card payment was successful.'});
									axios.post(`/account/api/payment/confirm_card_payment`,
									{
										paymentIntentId: result.paymentIntent.id,
										selected_invoices: this.selectedInvoices,
									})
										.then(response => {
											console.log('SWM confirm invoice succeeded');
											console.log(response.data);
											if (response.data.status === 'PaymentSucceeded' && response.data.redirect) {
												console.log(`Redirecting to ${response.data.redirect}`);
												window.location = response.data.redirect;
											}
											this.paymentInProgress = false;
										}).catch(error => {
										if (error.response) {
											console.log(error.response);
											this.$message({message: error.response.data.message, type: 'error'});
										} else {
											this.$message({message: 'There was a problem paying the invoice in Swim Manager.', type: 'error'});
										}
										this.paymentInProgress = false
									});
								}
							})
						}
						else {
							this.$message({message: error.response.data.message, type: 'error'});
							this.paymentInProgress = false;
							this.loadingInstance.close();

						}
						
					});
				},
				handleHTTPError(error) {
						if (error.response) {
							// The request was made and the server responded with a status code
							// that falls out of the range of 2xx
							console.log(error.response.data); // Error message
							console.log(error.response.status);
							console.log(error.response.headers);
						} else if (error.request) {
							// The request was made but no response was received
							// `error.request` is an instance of XMLHttpRequest in the browser and an instance of
							// http.ClientRequest in node.js
							console.log(error.request);
						} else {
							// Something happened in setting up the request that triggered an Error
							console.log('Error', error.message);
						}
						console.log(error.config);
				},
				roundHalfUp(number, precision) {
					var factor = Math.pow(10, precision);
					var tempNumber = number * factor;
					var roundedTempNumber = Math.round(tempNumber); // Rounds towards +infinity - i.e. half up on positive numbers
					return +((roundedTempNumber / factor).toFixed(2));
				},
				formatCurrency(number) {
					let ourLocale = Intl.NumberFormat(this.paymentConfig.intl_locale, {
						style: 'currency',
						currency: this.paymentConfig.currency_iso_code
					});
					return ourLocale.format(number);

				}, 
				transactionFees(country) {
					
					// Note that this calculates the amount that needs to be added to the amoun in order to result
					// in the net amount being deposited
					
					// @see https://stripe.com/docs/connect/direct-charges
					
					// Net Deposit = Charge - Application Fee - Stripe Fixed Fee - ( Charge * 0.029)
					// (Net Deposit + Application fee + Stripe Fixed Fee) / (1 - 0.029)		[where 0.029 = Stripe US fee]
					
					if (this.paymentAmountInPence && this.paymentConfig) {
						let fees = this.stripeFees(country);
						return this.roundHalfUp((((
							this.paymentAmountInPence 
							+ fees.fixed_fee 
							+ this.paymentConfig.payment_methods.card.stripe_application_fee
							) /
							(1 - (fees.percentage / 100))
							- this.paymentAmountInPence) / 100),2);
					} else {
						return 0;
					}
				},
		        stripeFees(country) {

					/*  
					EU Countries
					Austria, Belgium, Bulgaria, Croatia, Republic of Cyprus, Czech Republic, Denmark, Estonia, 
					Finland, France, Germany, Greece, Hungary, Ireland, Italy, Latvia, Lithuania, Luxembourg, 
					Malta, Netherlands, Poland, Portugal, Romania, Slovakia, Slovenia, Spain and Sweden
					
					EEA Countries
					EEA includes EU countries and also Iceland, Liechtenstein and Norway
					*/
					let eea_countries = [
					'AT','BE','BG','HR','CY','CZ','DK','EE','FI','FR','DE','GR','HU','IE','IT','LV','LT','LU',
					'MT','NL','PL','PT','RO','SK','SI','ES','SE','IS','LI','NO'
					];
					if (country === 'GB') {
						return {
							percentage: this.paymentConfig.payment_methods.card.stripe_percentage_fee_gb,
							fixed_fee: this.paymentConfig.payment_methods.card.stripe_fixed_fee_gb
						};
					}
					if (eea_countries.includes(country)) {
						return {
							percentage: this.paymentConfig.payment_methods.card.stripe_percentage_fee_eu,
							fixed_fee: this.paymentConfig.payment_methods.card.stripe_fixed_fee_eu
						};
					}
					
					return {
						percentage: this.paymentConfig.payment_methods.card.stripe_percentage_fee_intl,
						fixed_fee: this.paymentConfig.payment_methods.card.stripe_fixed_fee_intl
					};
				},

			}
	}
</script>